import { Injectable, inject, signal } from '@angular/core';
import { ScrollService } from '../../../services/scroll.service';
import { StaticContentService } from 'src/app/core/services/static-content.service';
import { filter } from 'rxjs';
import { MenuItemType } from 'src/app/core/types/menu.type';
import { toBoolean } from 'src/app/core/helpers/mapper';

@Injectable({
  providedIn: 'root',
})
export class SideNavService {

  private _scroll = inject(ScrollService);
  private _staticContent = inject(StaticContentService);

  public sideMenu = signal<{topList?: MenuItemType[], menuList?: MenuItemType[]}>({});
  public mobileMenu = signal<any>({});

  /**
   * Sidebar state
   */
  public isOpen = signal<boolean>(false);

  /**
   * Open side-nav
   */
  public open() {
    if (!this.isOpen()) {
      this._scroll.blockScroll();
      setTimeout(() => {
        this.isOpen.set(true);
      }, 100);
    }
  }

  /**
   * Close side-nav
   */
  public close() {
    if (this.isOpen()) {
      this._scroll.UnblockScroll();
      setTimeout(() => {
        this.isOpen.set(false);
      }, 200);
    }
  }

  /**
   * Toggle side-nav
   */
  public toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  public loadMenu() {
    this._staticContent.item({slug: 'winthrone-menu'}).pipe(
      filter(e => !!e)
    ).subscribe(e => {
      if (e[0]) {
        this.sideMenu.set(this._mapSideMenu(e[0]));
        this.mobileMenu.set(this._mapMobileMenu(e[0]));
      }
    })
  }

  private _mapSideMenu(data: any) {
    const topList: any[] = [];
    const menuList: any[] = [];

    Object.values(data?.SideBarTopMenu || {}).forEach((e: any) => {
      topList.push({
        ...e,
        order: Number(e?.order || 0),
        hide: toBoolean(e?.hide),
        imgSrc: data['SideBarTopMenuIcon' + e?.order]
      });
    });

    Object.values(data?.SideBarMenu || {}).forEach((e: any) => {
      menuList.push({
        ...e,
        order: Number(e?.order || 0),
        hide: toBoolean(e?.hide),
        imgSrc: data['SideBarMenuIcon' + e?.order]
      });
    });

    return {
      topList: topList
        .filter(e => !e.hide)
        .sort((a, b) => a?.order - b?.order),
      menuList: menuList
        .filter(e => !e.hide)
        .sort((a, b) => a?.order - b?.order)
    };
  }

  private _mapMobileMenu(data: any) {
    const menuList: any = {};
    Object.keys(data).forEach(e => {
      if (e.includes('MobileMenuIcon')) {
        menuList[e] = data[e];
      }
    });
    return menuList;
  }

}
